"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";

const cards = [
  {
    name: "Stripe",
    image: "/image-264.webp",
    desc: "Supports HK entities. Requires company docs, business description, operational website, and director ID verification.",
    width:57,
    height:32
  },
  {
    name: "PayPal",
    image: "/image-265.svg",
    desc: "Accepts HK limited companies. Supports international payments, subscription billing, and cross-border transactions.",
     width:26,
    height:32
  },
  {
    name: "Airwallex",
    image: "/image-266.svg",
    desc: "Strong for eCommerce founders with Stripe integrations and global supplier payments and USD processing.",
     width:43,
    height:32
  },
  {
    name: "Wise Business",
    image: "/image-267.svg",
    desc: "Multi-currency receiving, international transfers, online dashboard. Used by consultants, agencies, and SaaS founders.",
     width:32,
    height:32
  },
  {
    name: "Payoneer",
    image: "/image-268.svg",
    desc: "Works with HK entities. Commonly used by Amazon sellers, freelancers, agency operators, and international marketplaces.",
     width:32,
    height:32
  },
];

export default function BankingSetupSection({ heading = "What We Handle Inside Your HK Banking Setup" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[30px] md:py-[60px] px-4">
      {/* CONTAINER */}
      <div className="max-w-[1200px] mx-auto flex flex-col items-center gap-12">

        {/* HEADING */}
        <div className="max-w-[780px] text-center space-y-6">
          <Heading as="h2" variant="sectionCentered" className="max-w-[650px] mx-auto">
            {heading}
          </Heading>

          <p className="text-white/70 text-[16px] leading-6">
            Opening an account successfully requires more than submitting a form.
            MuteTaxes supports your entire application — dramatically improving
            approval probability compared to applying independently.
          </p>
        </div>

        {/* GRID */}
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-6 w-full items-start">
  {cards.map((card, i) => (
    <div
      key={i}
      className={`border border-white/10 rounded-xl p-3 md:p-6 flex flex-col md:gap-[32px] gap-[18px] hover:shadow-md transition
      ${i === cards.length - 1 ? "col-span-2 lg:col-span-1" : ""}`}
    >
      <Image
        src={card.image}
        alt={card.name}
        width={card.width}
        height={card.height}
        className="object-contain"
      />

      <div className="space-y-2">
        <p className="text-[12px] text-white/60">{card.name}</p>

        <p className="text-[14px] md:text-[18px] leading-[120%] font-medium text-white">
          {card.desc}
        </p>
      </div>

      <p className="text-[12px] text-green-600">✓ Accepted</p>
    </div>
  ))}
</div>
      </div>
    </section>
  );
}